import xhook from 'xhook';
import { initSetup, askMeSetup } from './setup';
import { initAuth, startRefreshToken } from './auth';
import { initPayment } from './payment';
import { initLocation } from './location';
import { initScanner } from './scanner';
import { initShare } from './share';

const defineAppCallbacks = () => {
    initSetup();
    initAuth();
    initPayment();
    initLocation();
    initScanner();
    initShare();
}

const interceptorSetup = () => {
    xhook.before((request) => {
        if ((request.url.includes("cielo") || request.url.includes("redpay")) && !request.headers.Authorization) {
            console.log("Gateway Interceptor: Adicionando token de autorização.");
            request.xhr.setRequestHeader('Authorization', 'Bearer ' + sessionStorage.getItem("authorization"));
        }
    });

    xhook.after((request, response) => {
        if (
            (request.url.includes("cielo") || request.url.includes("redpay")) && 
            response.status == 401) {
            startRefreshToken(onTokenRefreshed);
        }
    });
}

const onTokenRefreshed = () => {
    console.log("Token de autorização renovado.");
};

const init = (callback) => {
    defineAppCallbacks();
    interceptorSetup();
    console.log("Módulo instanciado, iniciando configuração...");

    askMeSetup(callback);
}

export default init;
